module.exports = __webpack_public_path__ + "img/ba747b529a778ea811d6eb94667fcd5c.png";